import { SpecReviewPanel } from '../../../features/exploratory-tests/components/SpecReviewPanel';
import { Box, TagBadge, Text } from '@chatsdet/ui';
import type { ExploratoryBrowserSession, ReviewFinding, SpecLedgerItem, SpecOrchestrationState, SpecReviewReportJson } from '../../../features/exploratory-tests/types';

type SpecReviewSidebarProps = {
  report: SpecReviewReportJson | null;
  findings: ReviewFinding[];
  runId: string;
  orchestration: SpecOrchestrationState | null;
  ledger: SpecLedgerItem[] | null;
  sessions: ExploratoryBrowserSession[];
  onSelectSession: (id: string) => void;
};

export function SpecReviewSidebar({ report, findings, runId, orchestration, ledger, sessions, onSelectSession }: SpecReviewSidebarProps) {
  return (
    <div className="w-[380px] shrink-0 flex flex-col border-l border-border bg-card">
      {(orchestration || ledger) && (
        <Box className="border-b border-border p-3 space-y-2">
          <Text size="xs" weight="semibold" className="uppercase tracking-wide text-muted-foreground">Orchestration</Text>
          {orchestration?.actors.map((actor) => (
            <Text key={actor.label} size="xs">{actor.label}: {actor.credentialName} · {actor.matchConfidence} confidence</Text>
          ))}
          {orchestration?.blockers.map((blocker) => (
            <Text key={`${blocker.code}-${blocker.ref}`} size="xs" className="text-destructive">{blocker.message}</Text>
          ))}
          {ledger && (
            <div className="flex flex-wrap gap-1">
              {ledger.map((item) => <TagBadge key={item.id} name={`${item.id} · ${item.status}`} color={item.status === 'verified' ? 'blue' : item.status === 'failed' ? 'orange' : item.status === 'blocked' ? 'yellow' : 'gray'} hideDot />)}
            </div>
          )}
        </Box>
      )}
      <SpecReviewPanel report={report} findings={findings} runId={runId}
        sessions={sessions}
        onSelectSession={onSelectSession}
      />
    </div>
  );
}
